import React from 'react';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../../../constans/mixpanel-contants';
import { QuestionState } from '../../../../../constans/question-enums';
import { getMixpanelService } from '../../../../../utils/services/mixpanel-service-instance';
import ActionButton from '../../../../shared/action-button/action-button';
import { IActionButtonProps } from '../question-action-buttons';

const ActionButtons: React.FC<IActionButtonProps> = ({ isDisabled, updateHandler, buttonProperties }): JSX.Element => {

  const updateActionHandler = (state: QuestionState) => {
    const mixpanelEventType = state === QuestionState.ANSWERED || state === QuestionState.REMOVED;
    updateHandler(state);

    if (mixpanelEventType) {
      const eventToSend = state === QuestionState.ANSWERED ? MIXPANEL_EVENT_TYPES.QUESTION_ANSWERED : MIXPANEL_EVENT_TYPES.QUESTION_REMOVED;
      getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.QA, eventToSend);
    }
  };

  return (
    <>
      {buttonProperties.map((props, idx) => (
        <ActionButton
          key={idx}
          isDisabled={isDisabled}
          customClasses={props.cls}
          onClick={() => updateActionHandler(props.state)}
        >
          {props.buttonText}
        </ActionButton>
      ))}
    </>
  );
};

export default ActionButtons;

